import { notFound as routerNotFound, redirect as routerRedirect, useLocation, useRouter as useTanstackRouter } from "@tanstack/react-router";
import { useMemo } from "react";

import { refreshActiveViews } from "@/lib/query";

export interface NavigateOptions {
  scroll?: boolean;
}

export interface AppRouter {
  push: (href: string, options?: NavigateOptions) => void;
  replace: (href: string, options?: NavigateOptions) => void;
  back: () => void;
  forward: () => void;
  refresh: () => void;
  prefetch: (href: string) => void;
}

// next/navigation useRouter 대체(D3) — refresh 는 지금 화면의 읽기를 다시 읽는다(D5) · 액션 봉투 invalidate 가 이미 다시 읽는 것은 건너뛴다(W0k).
export const useRouter = (): AppRouter => {
  const router = useTanstackRouter();
  return useMemo(
    () => ({
      push: (href, options) => void router.navigate({ href, resetScroll: options?.scroll !== false }),
      replace: (href, options) => void router.navigate({ href, replace: true, resetScroll: options?.scroll !== false }),
      back: () => router.history.back(),
      forward: () => router.history.forward(),
      refresh: () => void refreshActiveViews(),
      prefetch: () => undefined,
    }),
    [router]
  );
};

export const usePathname = (): string => useLocation({ select: (location) => location.pathname });

export const useSearchParams = (): URLSearchParams => {
  const search = useLocation({ select: (location) => location.searchStr });
  return useMemo(() => new URLSearchParams(search), [search]);
};

// 서버 페이지에만 있던 두 함수 — loader 안에서 던지면 라우터가 notFoundComponent·이동으로 받는다.
export const notFound = (): never => {
  throw routerNotFound();
};

export const redirect = (href: string): never => {
  throw routerRedirect({ href });
};
